import { c as _c } from "react/compiler-runtime";
import type { DataIdentifier } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
type FinancialPermissionsProps = {
  title: string;
  permissions: DataIdentifier[];
};
const FinancialPermissions = t0 => {
  const $0 = _c(13);
  const {
    title,
    permissions
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.userData.financial"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  let t2;
  if ($0[1] !== title) {
    t2 = <h3 className="text-label-2">{title}</h3>;
    $0[1] = title;
    $0[2] = t2;
  } else {
    t2 = $0[2];
  }
  let t3;
  if ($0[3] !== permissions || $0[4] !== t) {
    let t4;
    if ($0[6] !== t) {
      t4 = permission => <div key={permission} className="text-body-2">{t($ => $[permission])}</div>;
      $0[6] = t;
      $0[7] = t4;
    } else {
      t4 = $0[7];
    }
    t3 = permissions.map(t4);
    $0[3] = permissions;
    $0[4] = t;
    $0[5] = t3;
  } else {
    t3 = $0[5];
  }
  let t4;
  if ($0[8] !== t3) {
    t4 = <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-3">{t3}</div>;
    $0[8] = t3;
    $0[9] = t4;
  } else {
    t4 = $0[9];
  }
  let t5;
  if ($0[10] !== t2 || $0[11] !== t4) {
    t5 = <div className="flex flex-col gap-3 p-3 px-4 rounded bg-secondary">{t2}{t4}</div>;
    $0[10] = t2;
    $0[11] = t4;
    $0[12] = t5;
  } else {
    t5 = $0[12];
  }
  return t5;
};
export default FinancialPermissions;